// resortsByCategory.js

const resortsByCategory = {
  "Deluxe Resorts": [
    {
      name: "Disney's Grand Floridian Resort & Spa",
      category: "Deluxe Resorts",
      resortNotes: ["Luxury", "Monorail Access", "Romantic"],
    },
    {
      name: "Disney's Contemporary Resort",
      category: "Deluxe Resorts",
      resortNotes: [
        "Modern",
        "Monorail Access",
        "Walk to Magic Kingdom",
      ],
    },
    {
      name: "Disney's Polynesian Village Resort",
      category: "Deluxe Resorts",
      resortNotes: [
        "Island Theming",
        "Monorail Access",
        "Great Dining",
      ],
    },
    {
      name: "Disney's Wilderness Lodge",
      category: "Deluxe Resorts",
      resortNotes: ["Rustic", "Scenic", "Boat to Magic Kingdom"],
    },
    {
      name: "Disney's Animal Kingdom Lodge",
      category: "Deluxe Resorts",
      resortNotes: [
        "Unique Experience",
        "Savanna Views",
        "Great for Kids",
      ],
    },
    {
      name: "Disney's Yacht Club Resort",
      category: "Deluxe Resorts",
      resortNotes: ["Close to EPCOT", "Best Pool", "Walk to Boardwalk"],
    },
    {
      name: "Disney's Beach Club Resort",
      category: "Deluxe Resorts",
      resortNotes: ["Great Pool", "EPCOT Access", "Family Friendly"],
    },
    {
      name: "Disney's BoardWalk Inn",
      category: "Deluxe Resorts",
      resortNotes: ["Entertainment", "Nightlife", "EPCOT Access"],
    },
    {
      name: "Disney's Riviera Resort",
      category: "Deluxe Resorts",
      resortNotes: ["Newest", "Skyliner Access", "Elegant Design"],
    },
  ],
  "Deluxe Villas": [
    {
      name: "Bay Lake Tower at Disney’s Contemporary Resort",
      category: "Deluxe Villas",
      resortNotes: ["DVC", "Walk to Magic Kingdom", "Monorail Access"],
    },
    {
      name: "Boulder Ridge Villas at Disney’s Wilderness Lodge",
      category: "Deluxe Villas",
      resortNotes: ["Quiet", "Nature Feel", "Boat to MK"],
    },
    {
      name: "Copper Creek Villas & Cabins at Disney’s Wilderness Lodge",
      category: "Deluxe Villas",
      resortNotes: ["Cabin Options", "Luxury Rustic", "MK Area"],
    },
    {
      name: "Disney’s Animal Kingdom Villas – Jambo House",
      category: "Deluxe Villas",
      resortNotes: ["Savanna Views", "African Theming", "DVC"],
    },
    {
      name: "Disney’s Animal Kingdom Villas – Kidani Village",
      category: "Deluxe Villas",
      resortNotes: ["Spacious Rooms", "Kid Friendly", "Savanna Access"],
    },
    {
      name: "Disney’s Beach Club Villas",
      category: "Deluxe Villas",
      resortNotes: ["Best Pool", "Walk to EPCOT", "DVC"],
    },
    {
      name: "Disney’s BoardWalk Villas",
      category: "Deluxe Villas",
      resortNotes: ["Nightlife", "EPCOT Access", "DVC"],
    },
    {
      name: "Disney’s Old Key West Resort",
      category: "Deluxe Villas",
      resortNotes: [
        "Laid Back",
        "Spacious Rooms",
        "Great for Large Groups",
      ],
    },
    {
      name: "Disney’s Saratoga Springs Resort & Spa",
      category: "Deluxe Villas",
      resortNotes: ["Near Disney Springs", "Golf Access", "Quiet"],
    },
    {
      name: "The Villas at Disney’s Grand Floridian Resort & Spa",
      category: "Deluxe Villas",
      resortNotes: ["Luxury", "Spa Access", "Monorail"],
    },
  ],
  "Moderate Resorts": [
    {
      name: "Disney’s Caribbean Beach Resort",
      category: "Moderate Resorts",
      resortNotes: [
        "Skyliner Access",
        "Island Theming",
        "Large Layout",
      ],
    },
    {
      name: "Disney’s Coronado Springs Resort",
      category: "Moderate Resorts",
      resortNotes: [
        "Convention Friendly",
        "Tower Rooms",
        "Southwest Style",
      ],
    },
    {
      name: "Disney’s Port Orleans Resort – Riverside",
      category: "Moderate Resorts",
      resortNotes: ["Romantic", "Southern Charm", "Riverside Boat"],
    },
    {
      name: "Disney’s Port Orleans Resort – French Quarter",
      category: "Moderate Resorts",
      resortNotes: ["Compact", "Jazz Theme", "Quiet Stay"],
    },
    {
      name: "The Cabins at Disney’s Fort Wilderness Resort",
      category: "Moderate Resorts",
      resortNotes: ["Cabin Privacy", "Nature", "Great for Families"],
    },
  ],
  "Value Resorts": [
    {
      name: "Disney’s Pop Century Resort",
      category: "Value Resorts",
      resortNotes: ["Budget Friendly", "Skyliner Access", "Fun Themes"],
    },
    {
      name: "Disney’s Art of Animation Resort",
      category: "Value Resorts",
      resortNotes: ["Themed Suites", "Skyliner", "Great for Kids"],
    },
    {
      name: "Disney’s All-Star Movies Resort",
      category: "Value Resorts",
      resortNotes: ["Budget", "Movie Themes", "Entry Level"],
    },
    {
      name: "Disney’s All-Star Music Resort",
      category: "Value Resorts",
      resortNotes: ["Budget", "Family Suites", "Music Themes"],
    },
    {
      name: "Disney’s All-Star Sports Resort",
      category: "Value Resorts",
      resortNotes: ["Budget", "Sports Themes", "Lively Atmosphere"],
    },
  ],
  Campgrounds: [
    {
      name: "The Campsites at Disney’s Fort Wilderness Resort",
      category: "Campgrounds",
      resortNotes: ["RV Friendly", "Budget Option", "Nature Lovers"],
    },
  ],

  "Off Property": [
    {
      name: "Wyndham Garden Lake Buena Vista",
      category: "Off Property",
    },
    {
      name: "Hilton Orlando Buena Vista Palace",
      category: "Off Property",
    },
    {
      name: "Holiday Inn Disney Springs",
      category: "Off Property",
    },
    {
      name: "B Resort & Spa",
      category: "Off Property",
    },
  ],
};

export default resortsByCategory;